import { can } from './auth';

const unavailableName = 'Name Unavailable';
const redactedName = 'Microsoft';

export const viewableInitiatedByName = initiatedBy => {
  const initiatedName = initiatedBy.name || unavailableName;

  return can('viewActivityInitiatedBy') ? initiatedName : redactedName;
};

export const viewablePersonaProps = initiatedBy => {
  if (can('viewActivityInitiatedBy')) {
    if (initiatedBy.imageUrl) {
      return {
        text: viewableInitiatedByName(initiatedBy),
        imageUrl: initiatedBy.imageUrl,
      };
    }

    if (initiatedBy.name) {
      return {
        text: initiatedBy.name,
        imageInitials: initiatedBy.name
          .split(' ')
          .map(n => n[0].toUpperCase())
          .join('')
          ?.substring(0, 2),
      };
    }

    return {
      text: unavailableName,
    };
  }

  return {
    text: redactedName,
  };
};
